import "./BasicPaymentRecordParserDataGridWithColumnToggledStyle.css";

import React, { useCallback, useEffect, useRef, useState } from "react";
import { Typography, useTheme } from "@mui/material";

import { BasicPaymentRecordAmountHeaderColumns } from "../../VaidationParserHeaderColumns";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { RequestParams } from "@websential/cosmic-v20";

export interface IDataTable {
	rows: any;
	columns: any;
	showIndexColumn: boolean;
	showChecboxColumn: boolean;
	footer?: any;
	whiteSpace?: string;
	tableScrollHeight?: boolean;
	pageTitle?: string;
	showRowExpandedView?: boolean;
}



export const BasicPaymentRecordParserDataGrid: React.FC<IDataTable> = ({
	rows,
	columns,
	showChecboxColumn,
	footer,
	whiteSpace,
	tableScrollHeight,
	pageTitle,
	showRowExpandedView

}) => {

	const amountValidation = (amount: any, total: any) => {
		const amountNumber = Number(amount) / 100;
		const totalNumber = total && Number(total);
		if (amountNumber !== totalNumber) {
			return true
		}
		return false
	}
	const accountNoValidation = (a: any, b: any) => {
		if (a !== b) {
			return true
		}
		return false
	}

	// first check from last character to first is same b avail in a and all rest of numbers have only zero then return true 
	// like if b would be 021 then first condition would be false that b have 021 and a end with 012 and 
	// if a would be 01012 and b would be 012 then first condition true that a ends with 012 but second condition false because 
	// rest we dont have all zeros 0 so return false
	const financialInstitutionNumberValidation = (a: string, b: string) => {
		let aIndex = a.length - 1;
		let bIndex = b.length - 1;
		let isMatched = true;

		// Step 1: Compare from end
		while (bIndex >= 0) {
			if (a[aIndex] !== b[bIndex]) {
				isMatched = false;
				break;
			}
			aIndex--;
			bIndex--;
		}

		if (isMatched) {

			// Step 2: Get remaining part before matched b
			const remaining = a.substring(0, aIndex + 1); // remaining part

			// Step 3: Check if remaining is all zeros
			if (remaining === "" || /^[0]+$/.test(remaining)) {
				return true;
			} else {
				return false;
			}
		}
		return false;
	};

	const clientNameValidation = (a: any, b: any) => {
		if (a.toLowerCase() !== b.toLowerCase()) {
			return true
		}
		return false
	}

	const columnsSubBody = (rowData: any, row: any, x: any, parentRow: any) => {
		if (x.field === 'amount') {
			BasicPaymentRecordAmountHeaderColumns[BasicPaymentRecordAmountHeaderColumns.length - 1].footer = rowData.total;
			const amountColumnsBody = (rowData: any, row: any, x: any) => {
				if (x.field === 'clientName') {
					return (
						<Typography sx={{ fontSize: ".875rem" }}>
							{rowData[x.field].toLowerCase()}
						</Typography>
					)
				} else {
					return (
						<Typography sx={{ fontSize: ".875rem" }}>
							{rowData[x.field]}
						</Typography>
					)
				}
			};
			return (
				<DataTable
					value={
						rows &&
						rowData[x.field]
					}
					lazy
					dataKey="id"
					emptyMessage={
						rows && rows.length === 0 ? "No Record Found." : "Loading..."
					}
					className="BasicPaymentRecordAmountDataGrid"
				>
					{BasicPaymentRecordAmountHeaderColumns
						.sort((a: any, b: any) => (a.sequence ?? 0) - (b.sequence ?? 0))
						.map((x: any, index: any) => {
							return (
								<Column
									key={index}
									field={x.field}
									header={x.headerName}
									align={x.align}
									style={{
										width: x.minWidth,
										minWidth: x.minWidth,
										maxWidth: x.maxWidth,
										fontSize: "0.875rem",
										backgroundColor: "limegreen",
									}}
									className={
										amountValidation(parentRow.amount, rowData.total) ? "amount-validate" : ""}
									footer={x.footer}
									body={(rowData: any, row: any) =>
										amountColumnsBody(rowData, row, x)
									}
								/>
							);
						})}
				</DataTable>
			)
		} else if (x.field === 'customerNumber') {
			return (
				<Typography sx={{ fontSize: ".875rem" }}>
					{rowData[x.field].join(", ")}
				</Typography>
			)
		} else {
			return (
				<Typography sx={{ fontSize: ".875rem" }}>
					{rowData[x.field]}
				</Typography>
			)
		}
	};


	const rowExpansionTemplate = (data: any) => {
		return (
			<div>
				<DataTable value={data.orders} className="ExpandedDataGrid">
					{columns &&
						columns.map((x: any, index: any) => (
							<Column
								key={index}
								field={x.field}
								header={x.headerName}
								align={x.align}
								style={{
									width: x.minWidth,
									minWidth: x.minWidth,
									maxWidth: x.maxWidth,
									fontSize: "0.875rem",
									backgroundColor: x.field === "customerNumber" ? "green" : "limegreen",
									color: "#000"
								}}
								bodyClassName={(rowData: any, row: any) =>
									x.field === "accountNo" && accountNoValidation(data.accountNo, rowData.accountNo) ? "error-class" :
										x.field === "customerName" && clientNameValidation(data.customerName, rowData.customerName) ? "error-class" :
											x.field === "financialInstitutionNumber" && !financialInstitutionNumberValidation(data.financialInstitutionNumber, rowData.financialInstitutionNumber) ? "error-class" :
												x.field === "financialInstitutionBranchNumber" && !financialInstitutionNumberValidation(data.financialInstitutionBranchNumber, rowData.financialInstitutionBranchNumber) ? "error-class" :
													""
								}
								body={(rowData: any, row: any) =>
									columnsSubBody(rowData, row, x, data)
								}
							/>
						))}
				</DataTable>
			</div>
		);
	};


	const renderHeader = () => {
		return (
			<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				<div
					style={{
						fontSize: "1rem",
						fontWeight: "bold",
						fontFamily: "'Roboto','Helvetica','Arial',sans-serif",
					}}
				>
					{pageTitle}
				</div>
			</div>
		);
	};
	const headerSearch = renderHeader();

	const expandedRowsData = showRowExpandedView && rows
		? rows.reduce((acc: any, p: any) => {
			if (p.orders?.length) acc[p.id] = true;
			return acc;
		}, {})
		: undefined;


	return (
		<>
			<DataTable
				value={
					rows && rows
				}
				responsiveLayout="scroll"
				// lazy
				dataKey="id"

				editMode=""
				// selectionMode={"checkbox"}
				showGridlines
				// resizableColumns
				columnResizeMode="expand"
				scrollable
				scrollHeight={tableScrollHeight ? "75vh" : ""}
				// // reorderableColumns
				// onColReorder={onColReorder}
				header={headerSearch}
				footer={footer ? footer : undefined}
				emptyMessage={
					rows && rows.length === 0 ? "No Record Found." : "Loading..."
				}
				className="BasicPaymentRecordParserListDataGridWithColumnToggled"
				style={{
					marginBottom: `${"20px"}`,
				}}
				rowExpansionTemplate={showRowExpandedView ? rowExpansionTemplate : undefined}
				expandedRows={expandedRowsData}
			>
				{columns && (
					<Column
						selectionMode="multiple"
						hidden={!showChecboxColumn}
						frozen
						resizeable={false}
						style={{ width: "36px", textAlign: "center" }}
						field="selection"
						alignFrozen="left"
						columnKey="selection"
						className="selectionHeader"
						headerClassName="selectionHeader"
					></Column>
				)}

				{columns.sort((a: any, b: any) => (a.sequence ?? 0) - (b.sequence ?? 0))
					.map((x: any, index: any) => {
						return (
							<Column
								key={index}
								field={x.field}
								header={x.headerName}
								headerTooltip={x.description}
								headerTooltipOptions={{ position: "top" }}
								hidden={x.hide}
								// sortable={x.sortable}
								// resizeable={x.resizable}
								dataType={x.type}
								align={x.align}
								alignHeader={x.headerAlign}
								reorderable={x.disableReorder}
								exportable={x.disableExport}
								frozen={x.frozenColumn}
								alignFrozen={x.alignFrozen}
								columnKey={x.field}
								style={{
									width: x.minWidth,
									minWidth: x.minWidth,
									maxWidth: x.maxWidth,
									fontSize: "0.875rem",
								}}
								headerStyle={{ whiteSpace: whiteSpace ? whiteSpace : "nowrap" }}
								footer={x.footer}
								className={x.orders ? "hasOrdersTD" : ""}
							/>
						);
					})}
			</DataTable >
		</>
	);
};
